module.exports = __webpack_public_path__ + "img/115.bc5d510e.jpg";